module.exports = __webpack_public_path__ + "img/background.eb3365a6.jpg";